export const HOLDING_REPORT = "HOLDING_REPORT";
export const SELECTED_ROW_INDEX = "SELECTED_ROW_INDEX";
export const HOLDING_STREAM = "HOLDING_STREAM";
export const HOLDING_ERROR = "HOLDING_ERROR";
export const HOLDING_LOADER = "HOLDING_LOADER";
export const DP_TRANSACTION_HISTORY_HOLDING = "DP_TRANSACTION_HISTORY_HOLDING";
export const DP_IDS_HOLDING = "DP_IDS_HOLDING";
export const DP_TRANSACTION_HISTORY_LOADER = "DP_TRANSACTION_HISTORY_LOADER";
export const EMPTY_DP_TRANSACTION_VALIDATION = "EMPTY_DP_TRANSACTION_VALIDATION";
export const DP_TRANSACTION_MAIN_LOADER = "DP_TRANSACTION_MAIN_LOADER";
export const HIDE_EMPTY_DP_TRANSACTION_VALIDATION = "HIDE_EMPTY_DP_TRANSACTION_VALIDATION";
export const HOLDING_HIDE_ERROR = "HOLDING_HIDE_ERROR";
export const HOLDING_DOWNLOAD_STATUS = "HOLDING_DOWNLOAD_STATUS";
export const HOLDING_EMPTY_VALIDATION = "HOLDING_EMPTY_VALIDATION";
export const HOLDING_HIDE_EMPTY_VALIDATION = "HOLDING_HIDE_EMPTY_VALIDATION";
export const PROD_ASSET_FILTER_VAL_HOLDING = "PROD_ASSET_FILTER_VAL_HOLDING";
export const SAVE_SMTF = "SAVE_SMTF";
